import PageHeader from "@/components/PageHeader";
import Testimonials from "@/components/Testimonials";
import CtaBand from "@/components/CtaBand";
import { motion } from "framer-motion";
import { useSeo } from "@/lib/seo";

function GuestFilm() {
  return (
    <section className="mx-auto max-w-3xl px-4 py-16 sm:px-6" data-testid="guest-film-section">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.7 }}
        className="overflow-hidden rounded-3xl border-2 border-[#f8b818]/40 bg-[#0a0a0b] shadow-[0_20px_60px_rgba(36,28,13,0.3)]"
        data-testid="guest-film-card"
      >
        <video
          src="/review-video.mp4"
          controls
          playsInline
          preload="metadata"
          className="aspect-video w-full"
          data-testid="guest-film-video"
        />
      </motion.div>
      <p className="mt-4 text-center text-xs font-extrabold uppercase tracking-widest text-[#8a7b5e]">
        Sent in by a guest — real riders, real fun. Share yours with the front desk to be featured.
      </p>
    </section>
  );
}

export default function ReviewsPage() {
  useSeo({
    title: "Guest Reviews | Cool Runnings Cape Town",
    description:
      "See what families, teachers and thrill-seekers say about Cool Runnings — Africa's first downhill toboggan park in Cape Town.",
    keywords: "Cool Runnings reviews, toboggan park reviews Cape Town, family attraction ratings Cape Town",
    image: "/og/reviews.jpg",
  });
  return (
    <>
      <PageHeader
        goodgirlTitle
        pageName="Reviews"
        eyebrow="Reviews & ratings"
        title="WORD ON THE TRACK"
        subline="Read what families, schools and adrenaline hunters say — then share the story of your own visit."
        image="/products/traffic-jam-summit.jpg"
      />
      <Testimonials />
      <GuestFilm />
      <CtaBand />
    </>
  );
}
